import React, { useContext, useState ,useEffect ,useRef } from "react";
import { Form } from "react-bootstrap";
import { csrfToken } from "../../../utis/csrfTokenUtils";
import UserInfoContext from "../../../utis/userInfoContext";
import CustomInput from "../../CommonComponents/CustomForm/CustomInputField";
import { networkService } from "../../config/axios";
import Button from "../../Elements/Button";
import CommonModal from "../../Modals/CommonModal";
import "./HandleUiModal.css";
import PreviewUi from "./PreviewUi";
import {
  COOKIE_CONSENT_DEFAULT_CONFIG,
  cloneCookieConsentDefaults,
} from "../../../constants/cookieConsentDefaults";

const HandleUiModal = ({ openModal, closeModal, customizationId, isEdit }) => {
  const { setShowNotifications, userInfoData } = useContext(UserInfoContext);

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [fieldsData, setFieldsData] = useState(() =>
    cloneCookieConsentDefaults(userInfoData?.privacy_link)
  );
  const [initialFieldsData, setInitialFieldsData] = useState(
    JSON.stringify(fieldsData)
  );

  const hasFetchedRef = useRef(false);

  useEffect(() => {
    if (userInfoData?.privacy_link) {
      setFieldsData((prev) => ({
        ...prev,
        link_details: {
          ...prev.link_details,
          link_url: prev.link_details.link_url === COOKIE_CONSENT_DEFAULT_CONFIG.link_details.link_url
            ? userInfoData.privacy_link
            : prev.link_details.link_url,
        },
      }));
    }
  }, [userInfoData?.privacy_link]);

  useEffect(() => {
    const fetchCustomization = async () => {
      try {
        const response = await networkService("/customizations.json", "GET");
        if (response?.data?.customizations) {
          const foundCustomization = response.data.customizations.find(
            (c) => c.id === customizationId
          );

          if (foundCustomization) {
            const safeParse = (str, defaults = {}) => {
              if (!str) return defaults;
              const jsonStr = str.replace(/=>/g, ":");
              try {
                return { ...defaults, ...JSON.parse(jsonStr) };
              } catch (e) {
                console.error("JSON parse failed:", str, e);
                return defaults;
              }
            };

            const newFields = {
              pp_text: foundCustomization.pp_text || "",
              modal_details: safeParse(
                foundCustomization.modal_details,
                COOKIE_CONSENT_DEFAULT_CONFIG.modal_details
              ),
              link_details: safeParse(
                foundCustomization.link_details,
                COOKIE_CONSENT_DEFAULT_CONFIG.link_details
              ),
              value: safeParse(
                foundCustomization.value,
                COOKIE_CONSENT_DEFAULT_CONFIG.value
              ),
            };

            setFieldsData(newFields);
            setInitialFieldsData(JSON.stringify(newFields));
          }
        }
      } catch (error) {
        console.error("Error fetching customization:", error);
      }
    };

    if (openModal && customizationId && !hasFetchedRef.current && isEdit) {
      fetchCustomization();
      hasFetchedRef.current = true;
    }
  }, [openModal, customizationId, isEdit]);

  const hasChanges = () => JSON.stringify(fieldsData) !== initialFieldsData;

  const handleChange = ({ target: { value, name } }) => {
      const sections = ["modal_details", "value", "link_details"];
      const targetKey = sections.find(
        (key) => fieldsData[key] && name in fieldsData[key]
      );

      console.log("handleChange:", { name, value, targetKey });

      if (targetKey) {
        setFieldsData((prev) => ({
          ...prev,
          [targetKey]: {
            ...prev[targetKey],
            [name]: value,
          },
        }));
      } else {
        setFieldsData((prev) => ({
          ...prev,
          [name]: value,
        }));
      }
    };


  const handleSubmit = async (e) => {
      e.preventDefault();
      const data = {
        approved: isEdit,
        id: customizationId,
        authenticity_token: csrfToken(),
        ...fieldsData,
      };

      await networkService(`update_text/${customizationId}.json`, "PATCH", data)
        .then((response) => {
          if (response.status == 200 || response.status == 201) {
            setInitialFieldsData(JSON.stringify(fieldsData));
            closeModal(false);
            setShowNotifications({
              showToast: true,
              toastType: "success",
              toastMessage: "Customization Request sent successfully",
            });
          }
        })
        .catch((error) => {
          setShowNotifications({
            showToast: true,
            toastType: "danger",
            toastMessage: "Something went wrong",
          });
        });
    };
  const handleReset = () => {
    const defaults = cloneCookieConsentDefaults(userInfoData?.privacy_link);
    setFieldsData(defaults);
  };

  return (
    <>
      <CommonModal
        title={"Consent Modal Options"}
        modalStatus={openModal}
        changeActiveStatus={() => closeModal(false)}
        centered
        footer={
          <div className="d-flex justify-content-between w-100">
            <Button
              text={"Reset to default"}
              classList={"outline"}
              type="button"
              onClick={handleReset}
            />
            <Button
              text={"Save"}
              classList={"success"}
              type="button"
              disabled={isEdit && !hasChanges()}
              onClick={(e) => {
                if (isEdit && hasChanges()) {
                  setShowConfirmModal(true);
                } else if (!isEdit) {
                  handleSubmit(e);
                }
              }}
            />
          </div>
        }
      >
        <div className="domain-main">
          <div className="customise-wrap-main">
            <div className="custo-cook">
              <h3>
                Customize the cookie consent text (maximum 500 characters)
              </h3>
            </div>
            <div className="custo-textarea-wrap">
              <Form.Control
                as="textarea"
                placeholder="Add the text here"
                name='pp_text'
                value={fieldsData?.pp_text}
                onChange={handleChange}
                style={{ height: "100px" }}
              />
            </div>
            <div className="row border-const-pre">
              <div className="col-6 border-constent">
                <div>
                  <h6 className="m-0">
                    <b>Border</b>
                  </h6>
                </div>
                <div className="">
                  <div className="d-flex customise-main-inp align-items-center gap-2">
                    <label>Weight</label>
                    <CustomInput
                      placeholder={"border weight"}
                      value={fieldsData?.modal_details?.border_weight}
                      name={"border_weight"}

                      onChange={handleChange}
                      type={"number"}
                      onKeyDown={(evt) =>
                        ["e", "E", "+", "-",].includes(evt.key) &&
                        evt.preventDefault()
                      }
                    />
                  </div>
                </div>
                <div className="">
                  <div className="d-flex customise-main-inp align-items-center gap-2">
                    <label>Background color</label>
                    <CustomInput
                      placeholder={"background color"}
                      value={fieldsData?.modal_details?.bg_color}
                      name={"bg_color"}
                      onChange={handleChange}
                      type={"text"}
                    />
                  </div>
                </div>

                <div className="">
                  <div className="d-flex customise-main-inp align-items-center gap-2">
                    <label>Border color</label>
                    <CustomInput
                      placeholder={"border color"}
                      value={fieldsData?.modal_details?.border_color}
                      name={"border_color"}
                      onChange={handleChange}
                      type={"text"}
                    />
                  </div>
                </div>
                <div className="mt-1 laser-set-h">
                  <h6>
                    <b>Link Settings</b>
                  </h6>
                  <div className="d-flex  row">
                    <div className="col-12">
                      <div className="d-flex align-items-center">
                        <div className="d-flex customise-main-inp align-items-center gap-2">
                          <label>Text</label>
                          <CustomInput
                            placeholder={"privacy notice"}
                            value={fieldsData?.link_details?.link_text}
                            name={"link_text"}
                            onChange={handleChange}
                            type={"text"}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="d-flex align-items-center">
                        <div className="d-flex customise-main-inp align-items-center mt-1 gap-2 w-100">
                          <label>URL</label>
                          <CustomInput
                            className="w-100"
                            placeholder={"privacy notice"}
                            value={fieldsData?.link_details?.link_url}
                            name={"link_url"}
                            onChange={handleChange}
                            type={"text"}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-6 border-constent">
                <PreviewUi fieldsData={fieldsData} />
              </div>
            </div>
          </div>
          <div className="customise-wrap-main mt-3">
            <div className="color-settings">
              <div>
                <h3>
                  <b> Left Button Colors</b>
                </h3>
              </div>
              <div className="color-row">
                <div className="color-input d-flex">
                  <label htmlFor="text-color-1">Text</label>
                  <CustomInput
                    placeholder={"text color"}
                    value={fieldsData?.value?.btn1_text_color}
                    name={"btn1_text_color"}
                    onChange={handleChange}
                    type={"text"}
                  />
                </div>
                <div className="color-input d-flex justify-content-center">
                  <label htmlFor="background-color-1">Background</label>
                  <CustomInput
                    placeholder={"text color"}
                    value={fieldsData?.value?.btn1_bg_color}
                    name={"btn1_bg_color"}
                    onChange={handleChange}
                    type={"text"}
                  />
                </div>
                <div className="color-input d-flex justify-content-end">
                  <label htmlFor="border-color-1">Border</label>
                  <CustomInput
                    placeholder={"border color"}
                    value={fieldsData?.value?.btn1_border_color}
                    name={"btn1_border_color"}
                    onChange={handleChange}
                    type={"text"}
                  />
                </div>
              </div>
              <div>
                <h3>
                  <b> Right Button Colors</b>
                </h3>
              </div>
              <div className="color-row">
                <div className="color-input d-flex">
                  <label htmlFor="text-color-1">Text</label>
                  <CustomInput
                    placeholder={"text color"}
                    value={fieldsData?.value?.btn2_text_color}
                    name={"btn2_text_color"}
                    onChange={handleChange}
                    type={"text"}
                  />
                </div>
                <div className="color-input d-flex justify-content-center">
                  <label htmlFor="background-color-1">Background</label>
                  <CustomInput
                    placeholder={"text color"}
                    value={fieldsData?.value?.btn2_bg_color}
                    name={"btn2_bg_color"}
                    onChange={handleChange}
                    type={"text"}
                  />
                </div>
                <div className="color-input d-flex justify-content-end">
                  <label htmlFor="border-color-1">Border</label>
                  <CustomInput
                    placeholder={"border color"}
                    value={fieldsData?.value?.btn2_border_color}
                    name={"btn2_border_color"}
                    onChange={handleChange}
                    type={"text"}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </CommonModal>

      {showConfirmModal && (
        <CommonModal
          title="Confirm Save"
          modalStatus={showConfirmModal}
          changeActiveStatus={() => setShowConfirmModal(false)}
          classList=" alert-modal"
          footer={
            <div className="d-flex justify-content-end gap-2 common-modal-yes-button">
              <Button
                text="Cancel"
                classList={"alert delete-btn"}
                type="button"
                onClick={() => setShowConfirmModal(false)}
              />
              <Button
                text="Save"
                classList={"success delete-btn"}
                type="button"
                onClick={(e) => {
                  setShowConfirmModal(false);
                  handleSubmit(e);
                }}
              />
            </div>
          }
        >
          Are you sure you want to save the changes?
        </CommonModal>
      )}
    </>
  );
};
export default HandleUiModal;
